export const INTERFACE_TEAM_MEMBERS = [
  { name: "Vamsi", email: "pvkrishna@thetravelagentnextdoor.com" },
  { name: "Dipti", email: "ddas@thetravelagentnextdoor.com" },
  { name: "Akshay", email: "akshayaks@thetravelagentnextdoor.com" },
  { name: "Lakshmi", email: "lakshmikn@thetravelagentnextdoor.com" },
  { name: "Halina", email: "hwerner@thetravelagentnextdoor.com" },
  { name: "Nagesh", email: "nananda@thetravelagentnextdoor.com" },
  { name: "Saran", email: "skumar@thetravelagentnextdoor.com" },
];
